import React from "react";
import Page from "@jumbo/shared/Page";
import DsokCustomerDetailProvider from "../data/DsokCustomerDetailProvider";
import DsokCustomerMaintenancePage from "../pages/DsokCustomerMaintenancePage";

export const dsokCustomerMaintenanceRoute = {
  path: "/dsok/customer-detail/:customerUrl/maintenance",
  element: (
    <DsokCustomerDetailProvider>
      <Page component={DsokCustomerMaintenancePage} />
    </DsokCustomerDetailProvider>
  ),
};
